<template>
    <div 
      class="">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.image"
            @keydown.esc="dialog.image = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Bukti Pembayaran
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.image = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                <v-img
                  :src="detail.payment_bukti_url"
                  contain
                  style="width: 100%; height: 100%;">
                </v-img>
              </v-card-text>
  
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
  
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.image = false; dialog.fullscreen = false;"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Tutup
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <section>
            <v-row
              class="pa-5 pb-0">
              <v-col
                cols="12">
                <v-card
                  to="/sales-order/transaksi-ditolak"
                  flat
                  color="transparent"
                  style="width: 50%;">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="POS Amanata"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
  
                    <span
                      class="fs-16 black--text ml-3"
                      style="font-weight: 600;">
                      Detail Transaksi Ditolak ( Pembayaran Ditolak )
                    </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-5 pt-0 pb-0">
              <v-col 
                cols="12"
                class="py-0">
                <v-card v-if="process.load && Object.keys(detail).length < 1"
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
                </v-card>
  
                <div v-if="!process.load && Object.keys(detail).length > 0">
                  <!-- <v-row>
                    <v-col cols="12" md="3">
                      <v-card flat style="background: #E8F5E9; border-radius: 10px;">
                        <v-card-text>
                          <div>
                            Kas Masuk
                          </div>
                          <div class="title black_one font_weight_600">
                            {{ detail.kas_masuk | price }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat style="background: #E8EAF6; border-radius: 10px;">
                        <v-card-text>
                          <div>
                            Penjualan
                          </div>
                          <div class="title black_one font_weight_600">
                            {{ detail.total_penjualan | price }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat style="background: #FFEBEE; border-radius: 10px;">
                        <v-card-text>
                          <div>
                            Kas Keluar
                          </div>
                          <div class="title black_one font_weight_600">
                            {{ detail.kas_keluar | price }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat style="background: #F5F5F5; border-radius: 10px;">
                        <v-card-text>
                          <div>
                            Sub Total
                          </div>
                          <div class="title black_one font_weight_600">
                            {{ detail.sub_total | price }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="12" md="7">
                      <v-row>
                        <v-col cols="12" md="3" class="pt-0">
                          <v-card flat style="background: #F5F5F5; border-radius: 10px;" class="mb-5">
                            <v-card-text>
                              <div>
                                Sub Total
                              </div>
                              <div class="title black_one font_weight_600">
                                {{ detail.sub_total | price }}
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="3" class="pt-0">
                          <v-card flat style="background: #FFEBEE; border-radius: 10px;" class="mb-5">
                            <v-card-text>
                              <div>
                                Total Diskon
                              </div>
                              <div class="title black_one font_weight_600">
                                {{ detail.discount_total | price }}
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="3" class="pt-0" v-if="config_outlet.is_count_ppn === '1'">
                          <v-card flat style="background: #FFCCBC; border-radius: 10px;" class="mb-5">
                            <v-card-text>
                              <div>
                                Pajak
                              </div>
                              <div class="title black_one font_weight_600">
                                {{ detail.tax | price }}
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="3" class="pt-0">
                          <v-card flat style="background: #C8E6C9; border-radius: 10px;" class="mb-5">
                            <v-card-text>
                              <div>
                                Total
                              </div>
                              <div class="title black_one font_weight_600">
                                {{ detail.total | price }}
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
  
                      <v-card 
                        flat
                        class="mb-5"
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-card-text>
                          <div class="fs-14">
                            Pembayaran Transaksi
                          </div>
                          <v-divider
                            class="mt-2 mb-4">
                          </v-divider>
                          <div class="d-flex">
                            <div style="width: 50%">
                              <div class="mb-3">
                                <div class="fs-12">
                                  Tanggal Pembayaran Transaksi
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  <span v-if="detail.customer_payment_date === ''">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ detail.customer_payment_date | date }}
                                  </span>
                                </div>
                              </div>
                              <div class="mb-3">
                                <div class="fs-12">
                                  Tipe Pembayaran
                                </div>
                                <div class="fs-14 black_one font_weight_600 text-capitalize">
                                  {{ detail.payment_method }}
                                </div>
                              </div>
                              <!-- <div class="mb-3">
                                <div class="fs-12">
                                  Nama Customer
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ detail.customer_name }}
                                </div>
                              </div>
                              <div class="mb-3">
                                <div class="fs-12">
                                  Nama Kasir
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ detail.kasir_input_name }}
                                </div>
                              </div> -->
                              <div class="">
                                <div class="fs-12">
                                  Total Bayar
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ detail.total | price }}
                                  <!-- <span v-if="detail.close_datetime === '' || detail.close_datetime === null">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ detail.close_datetime | datetime }}
                                  </span> -->
                                </div>
                              </div>
                            </div>
  
                            <div style="width: 50%">
                              <div class="">
                                <div class="fs-12 mb-1">
                                  Bukti Pembayaran
                                </div>
                                <div class="fs-14 black_one font_weight_600" v-if="detail.customer_payment_file_url === ''">
                                  -
                                  <!-- <span v-if="detail.close_datetime === '' || detail.close_datetime === null">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ detail.close_datetime | datetime }}
                                  </span> -->
                                </div>
                                <div v-else>
                                  <v-card 
                                    flat
                                    height="150"
                                    width="150"
                                    @click="dialog.image = true"
                                    class="d-flex align-center justify-center"
                                    style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
                                    <v-img
                                      :src="detail.customer_payment_file_url"
                                      contain
                                      style="width: 150px; height: 150px;"
                                    ></v-img>
                                  </v-card>
                                </div>
                              </div>
                              <!-- <div class="mb-3">
                                <div class="fs-12">
                                  Tipe Penjualan Makup
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ (detail.type_markup*1) }} %
                                </div>
                              </div>
                              <div class="mb-3">
                                <div class="fs-12">
                                  Tipe Penjualan Diskon
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ (detail.type_discount*1) }} %
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                      <v-card 
                        flat
                        class=""
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-card-text>
                          <div class="d-flex">
                            <div class="fs-14">
                              Informasi Shift Kasir
                            </div>
                            <div class="ml-auto">
                              <v-chip
                                small
                                class="px-5 font_weight_600 text-capitalize"
                                :style="detail.status !== 'selesai' ? 'color: white;' : 'color: white'"
                                :color="detail.status !== 'selesai' ? 'red' : 'green'"
                              >
                                {{ detail.status }}
                              </v-chip>
                            </div>
                          </div>
                          <v-divider
                            class="mt-2 mb-4">
                          </v-divider>
                          <div class="d-flex">
                            <div style="width: 30%">
                              <div class="mb-3">
                                <div class="fs-12">
                                  Tanggal Transaksi
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ detail.input_datetime | datetime }}
                                </div>
                              </div>
                            </div>
                            <div style="width: 30%">
                              <div class="mb-3">
                                <div class="fs-12">
                                  Nama Customer
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ detail.customer_name }}
                                </div>
                              </div>
                            </div>
                          </div>  
                          <div class="d-flex">
                            <div style="width: 30%">
                              <div class="mb-3">
                                <div class="fs-12">
                                  No. Transaksi
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ detail.so_number }}
                                </div>
                              </div>
                              <div class="mb-3">
                                <div class="fs-12">
                                  Tipe Transaksi
                                </div>
                                <div class="fs-14 black_one font_weight_600 text-capitalize">
                                  {{ detail.order_type }}
                                </div>
                              </div>
                            </div>
  
                            <div style="width: 30%">
                              <div class="mb-3">
                                <div class="fs-12">
                                  Nama Kasir
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ detail.kasir_input_name }}
                                </div>
                              </div>
  
                              <div class="mb-3">
                                <div class="fs-12">
                                  Tipe Penjualan
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ detail.type_name }}
                                  <!-- <span v-if="detail.close_datetime === '' || detail.close_datetime === null">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ detail.close_datetime | datetime }}
                                  </span> -->
                                </div>
                              </div>
                            </div>
  
                            <div style="width: 40%">
                              <div class="mb-3">
                                <div class="fs-12">
                                  Tipe Penjualan Makup
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ (detail.type_markup*1) }} %
                                </div>
                              </div>
                              <div class="mb-3">
                                <div class="fs-12">
                                  Tipe Penjualan Diskon
                                </div>
                                <div class="fs-14 black_one font_weight_600">
                                  {{ (detail.type_discount*1) }} %
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="mb-3">
                            <div class="fs-12">
                              Catatan
                            </div>
                            <div class="fs-16 black_one font_weight_600">
                              {{ detail.note === '' || detail.note === null ? '-' : detail.note }}
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>  
                    <v-col cols="12" md="5">
                      <v-card 
                        flat
                        class="mt-0"
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-card-text class="pb-0">
                          <div class="fs-14">
                            Item Penjualan
                          </div>
                          <v-divider
                            class="mt-2 mb-4">
                          </v-divider>
                        </v-card-text>
                        <v-card-text style="height: 610px; overflow: auto;" class="pt-0">
                          <div>
                            <!-- <v-card flat style="border-radius: 10px; border: 1px solid #E7E7E7;" v-for="(item, index) in detail.data_detail" :key="index" class="mb-4">
                              <v-card-text>
                                <div class="d-flex">
                                  <div>
                                    <div class="fs-14 black_one">
                                      {{ item.so_detail_item_sales_name_label }}
                                    </div>
                                    <div>
                                      {{ item.so_detail_item_sales_qty*1 }} / {{ item.so_detail_item_sales_satuan }}
                                    </div>
                                  </div>
                                  <div class="ml-auto">
                                    <div class="fs-14 black_one font_weight_600">
                                      {{ (item.so_detail_item_sales_qty*1) * (item.so_detail_item_sales_selling_price*1) | price }}
                                    </div>
                                  </div>
                                </div>
                                <div class="fs-14 black_one mt-1">
                                  {{ item.so_detail_item_note === '' || item.so_detail_item_note === null ? '-' : item.so_detail_item_note }}
                                </div>
                              </v-card-text>
                            </v-card> -->

                            <v-card flat style="border-radius: 10px; border: 1px solid #E7E7E7;" v-for="(item, index) in detail.data_detail" :key="index" class="mb-4">
                              <v-card-text>
                                <div class="d-flex black--text">
                                  <div>
                                    <div class="fs-13 black_one">
                                      {{ item.so_detail_item_sales_name_label }}
                                    </div>
                                  </div>
                                  <div class="ml-2 fs-13">
                                    ( {{ item.so_detail_item_sales_qty*1 }} / {{ item.so_detail_item_sales_satuan }} )
                                  </div>
                                  <div class="ml-auto">
                                    <div class="fs-13 black_one">
                                      {{ (item.so_detail_item_sales_qty*1) * (item.so_detail_item_sales_selling_price*1) | price }}
                                    </div>
                                  </div>
                                </div>
                                <div class="ml-2 black--text">
                                  <div class="fs-12 mt-2">
                                    Toping:
                                  </div>
                                  <div class="ml-2 black--text">
                                    <div v-for="(toping, tIndex) in item.topping" :key="tIndex"
                                      class="pt-1 fs-12 text-capitalize d-flex flex-wrap">
                                      <div class="black_one">
                                        {{ toping.topping_name }}
                                      </div>
                                      <div class="fs-12 ml-1">
                                        ( {{ toping.so_detail_topping_qty }} / {{ toping.so_detail_topping_satuan }} )
                                      </div>

                                      <div class="ml-auto">
                                        <span class="fs-12">
                                          {{ ((toping.so_detail_topping_selling_price*1)*(toping.so_detail_topping_qty*1)) | price }}
                                        </span>
                                      </div>
                                    </div>
                                    <div v-if="item.topping.length < 1"
                                      class="fs-12">
                                      -
                                    </div>
                                  </div>
                                </div>
                                <div class="fs-13 black_one mt-1">
                                  Catatan: {{ item.so_detail_item_note === '' || item.so_detail_item_note === null ? '-' : item.so_detail_item_note }}
                                </div>
                                <v-divider
                                  class="mt-2 mb-0"
                                  style="border-top: 1px dashed #E0E0E0;">
                                </v-divider>
                                <div class="d-flex justify-between mt-2">
                                  <div class="fs-14 black_one font_weight_600">
                                    Total Harga
                                  </div>
                                  <div class="ml-auto">
                                    <div class="fs-14 black_one font_weight_600">
                                      {{ (((item.so_detail_item_sales_qty*1) * (item.so_detail_item_sales_selling_price*1)) +
                                        (item.topping.reduce((a, b) => a + ((b.so_detail_topping_selling_price*1)*(b.so_detail_topping_qty*1)), 0))) | price }}
                                    </div>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
  
  
                <v-card v-if="!process.load && Object.keys(detail).length > 0"
                  class="mt-0"
                  flat>
                  <v-card-actions
                    class="px-0 pb-0">
                    <v-spacer/>
  
                    <!-- <v-btn
                      :disabled="process.form || process.export"
                      :loading="process.export"
                      color="#1A237E"
                      @click="exports()"
                      elevation="0"
                      width="120"
                      class="body-2 white--text text-capitalize d-flex align-center ml-4"
                      style="border-radius: 10px; font-weight: 600;">
                      <v-icon size="20">mdi-file-export</v-icon>
  
                      <span
                        class="ml-2">
                        Export
                      </span>
                    </v-btn> -->
                    
                    <v-btn
                      to="/sales-order/transaksi-ditolak"
                      :disabled="process.form || process.export"
                      color="red"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center ml-4"
                      style="border-radius: 10px; font-weight: 600;">
                      <v-icon 
                        size="20">
                        mdi-progress-close
                      </v-icon>
  
                      <span
                        class="ml-2">
                        Kembali
                      </span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          dialog: {
            fullscreen: false,
            snackbar: false,
  
            role: false,
            image: false
          },
          
          detail: {},
  
          role: [],
  
          list: [],
  
          form: {
            id: '',
            role_id: ''
          },
          config_outlet: {},
          
          process: {
            load: false,
  
            role: false,
            export: false,
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        
      },
      watch: {
        
      },
      computed: {
        company () {
          return this.$store.state.company
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        outlet () {
          return this.$store.state.outlet
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      beforeMount () {
        this.fetchDetail()
      },
      mounted () {
        
      },
      methods: {
        async fetchDetail () {
          this.process.load = true
  
          let params = {
            id: this.$route.params.id
          }
  
          await get(`pos/sales_order/detail_selesai`, { params })
          .then(response => {
            let res = response.data
  
            // this.process.load = false
  
            if (res.status === 200) {
              this.detail = res.results.data
              this.fetchDetailConfig()
            }
          })
        },
        async fetchDetailConfig () {
          this.process.load = true
  
          let params = {
            id: this.outlet.outlet_id
          }
  
          await get(`pos/outlet/detail`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
  
            if (res.status === 200) {
              this.config_outlet = res.results.data
            }
          })
        },
        async exports () {
          this.message.error = ''
  
          this.process.export = true
  
          let params = {
            id: this.$route.params.id
          }
  
          await axios({
            url: `${process.env.VUE_APP_API_URL}/pos/shift_kasir/export_pdf`,
            method: 'GET',
            responseType: 'blob', // important,
            params: params,
            headers: {
              Authorization: process.env.VUE_APP_XAUTH,
              token: TokenService.getToken()
            }
          }).then((response) => {
            let res = response
            // console.log(res)
  
            this.process.export = false
            let disposition = res.headers['content-disposition']
            var fileName = res.headers['content-disposition'].split('filename=')[1]
            let filename = ''
            if (disposition && disposition.indexOf('inline') !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) { 
                filename = matches[1].replace(/['"]/g, '');
              }
            }
  
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = 'Berhasil mengeksport pdf'
  
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement('a')
              link.href = url
  
              link.setAttribute('download', filename)
              document.body.appendChild(link)
  
              link.click()
            } else {
              this.message.error = res.message
            }
          })
        },
      }
    }
  </script>